/*
  Add to Cart visibility guard (PDP + quick add)

  Problem: after a sold-out size is selected, Klaviyo Back in Stock
  (app embed, back-in-stock-dynamic-button-handler.js) hides our
  .btn.add with `display: none !important` and remembers the button's
  inline display at that moment. Our theme has already set it to
  `none` (product_main.js, ProductButtons variantChange), so Klaviyo
  remembers "none". When an in-stock size is then selected, the theme
  clears the inline display, Klaviyo's MutationObserver sees its own
  button removed (onContainerRemoved) and writes the remembered
  `display: none` back. Add to Cart stays hidden until reload.

  Fix: whenever the selected variant is available (and no option
  selection is still required), keep the Add to Cart button from
  carrying an inline `display: none`. We only act while the variant is
  available, so the sold-out / Notify Me flow (theme or Klaviyo) is
  left alone. Klaviyo itself is not modified.
*/
(function () {
  if (window.__atcVisibilityGuard) return;
  window.__atcVisibilityGuard = true;

  // Safety valve: never fight another script in a loop.
  var MAX_REASSERTS_PER_CHANGE = 5;

  function unhide(btn) {
    var g = btn.__atcGuard;
    if (!g || !g.show) return;
    if (btn.style.display === 'none' && g.count < MAX_REASSERTS_PER_CHANGE) {
      g.count++;
      btn.style.removeProperty('display');
    }
  }

  function watch(btn) {
    if (btn.__atcGuardObserver) return;
    btn.__atcGuardObserver = new MutationObserver(function () { unhide(btn); });
    btn.__atcGuardObserver.observe(btn, { attributes: true, attributeFilter: ['style'] });
  }

  // variantChange is dispatched on the product-main element and does not
  // bubble; a capturing listener on document still receives it, before the
  // theme's own listeners run. We record the desired state here and let
  // the observer / next frame enforce it after the theme and Klaviyo act.
  document.addEventListener('variantChange', function (e) {
    var main = e.target;
    if (!main || typeof main.querySelectorAll !== 'function') return;
    var variant = e.detail && e.detail.variant;
    var selectionRequired = !!(main.requiredOptions && main.requiredOptions.length > 0);
    var show = !!(variant && variant.available) && !selectionRequired;

    main.querySelectorAll('product-buttons .btn.add').forEach(function (btn) {
      btn.__atcGuard = { show: show, count: 0 };
      if (!show) return;
      watch(btn);
      requestAnimationFrame(function () { unhide(btn); });
    });
  }, true);
})();
